<template>
  <div class="container">
	<div class="tabs">
    
		<input type="radio" id="radio-1" name="tabs" value="Advanced" v-model="radio" checked/>
		<label class="tab" for="radio-1">Advanced</label>
    	<input type="radio" id="radio-2" name="tabs" value="Intermediate" v-model="radio" />
		<label class="tab" for="radio-2">Intermediate</label>
		<input type="radio" id="radio-3" name="tabs" value="Beginner" v-model="radio" />
		<label class="tab" for="radio-3">Beginner</label>
    	<input type="radio" id="radio-4" name="tabs" value="Novice" v-model="radio" />
		<label class="tab" for="radio-4">Novice</label>
    	<input type="radio" id="radio-5" name="tabs" value="Relaxed" v-model="radio" />
		<label class="tab" for="radio-5">Relaxed</label>
    
		<span class="glider"></span>
   
	</div>
</div>
</template>

<script>
import ValidIcon from '@/components/ValidIcon.vue';
import Validate from '@/mixins/validate.js'

export default {
    name: "textInput",
    mixins:[Validate],
    components:{ValidIcon},
    props: {
        items: {
            type: Array,
            required: false,
            default: () => [],
        },
      

    },
    data() {
        return {
            radio:"Advanced"
           
           
        };
    },
    mounted() {
       
    },
    destroyed() {
        
    },
    computed:{
      
    },
    methods: {
      setValue(val){
		this.radio=val
	  }
       
    },
    watch:{
     radio(val){
      this.$emit("selected",val)
     }
    }
   
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import "@/css/colors.scss";

.container {
	
	
	display: flex;
	align-items: center;
	justify-content: center;
  	text-transform: none;
}
.tabs {
	display: flex;
	position: relative;
	border-radius: 99px; 
	* {
		z-index: 2;
	}
}

input[type="radio"] {
	display: none;
}

.tab {
	display: flex;
	align-items: center;
	justify-content: center;
	height: 3em;
	width: 10em;
	font-size: 1em;
	font-weight: 500;
	border-radius: 99px; 
	cursor: pointer;
	transition: color 0.15s ease-in;
}



input[type="radio"] {
	&:checked {
		& + label {
			color: #000;
      		font-weight:700;
			
		}
	}
}

input[id="radio-1"] {
	&:checked {
		& ~ .glider {
			transform: translateX(0);
      		background-color: $advanced-color
		}
	}
}

input[id="radio-2"] {
	&:checked {
		 & ~ .glider {
			transform: translateX(10em);
      background-color: $intermediate-color
		}
	}
}

input[id="radio-3"] {
	&:checked {
		& ~  .glider {
			transform: translateX(20em);
      background-color: $beginner-color;
		}
	}
}
  input[id="radio-4"] {
	&:checked {
		& ~  .glider {
			transform: translateX(300%);
      background-color: $novice-color;
		}
	}
}
input[id="radio-5"] {
	&:checked {
		& ~  .glider {
			transform: translateX(400%);
      background-color: $relaxed-color;
		}
	}
}

.glider {
	position: absolute;
	display: flex;
	height: 3em;
	width: 10em;
	background-color: var(--secondary-color);
	z-index: 1;
	border-radius: 99px; 
	transition: 0.25s ease-out;
}
</style>
